// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"190":"6d5bb72d","906":"c2c66b42","948":"211d3956"}[chunkId] + ".chunk.css";
};